<template lang="pug">
  div.body.body-table.operator-medic-table
    div.table-choose-panel
      div.toolbar-table
        e-select-list(
          :options="selectListOptions"
          v-model="operationType"
        )

        div.toolbar.toolbar--modal
          div.line
            div.actions-panel
              e-button-add(@click="addNewRowToTable()")
              // button(v-if="role!=='guest'" @click="addNewRowToTable()").actions-panel__button.btn-add.green

      div(v-if="operationType === 'opip'")
        e-table-editable(
        ref="operator"
        :attributes="operatorAttr"
        :dataUrl="operatorDataUrl"
        :postUrl="operatorPostUrl"
        :patchUrl="operatorPatchUrl"
        :deleteUrl="operatorDeleteUrl"
        :enableOnAdd="enableOnAdd"
        :afterFetchData="afterFetchData"
        :afterValidate="afterValidate"
        :tableInOnlineMode="tableInOnlineMode"
        )
      div(v-if="operationType === 'medic'")
        e-table-editable(
        ref="operatorMedic"
        :attributes="operatorMedicAttr"
        :dataUrl="operatorMedicDataUrl"
        :postUrl="operatorMedicPostUrl"
        :patchUrl="operatorMedicPatchUrl"
        :deleteUrl="operatorMedicDeleteUrl"
        :afterFetchData="afterFetchMedicData"
        :afterValidate="afterMedicValidate"
        :tableInOnlineMode="tableInOnlineMode"
        )

</template>

<script>
  import {garbage, core, tko} from '../../../api/api-endpoints.js'
  import {garbageOffline} from '../../../api/api-offline-endpoints.js'
  import operatorTableMixin from './mixins/operator-table-mixin.js'
  import {Neutralization, Burial} from '../../../config/config'

  export default {
    name: 'operator-medic-table',
    mixins: [operatorTableMixin],
    props: {
      tabView: null,
      id: null
    },
    data () {
      return {
        operationType: null
      }
    },
    computed: {
      selectListOptions () {
        return [
          {
            id: 'opip',
            name: 'Обслуживание объекта по ОПиП'
          },
          {
            id: 'medic',
            name: 'Обслуживание объекта по обработке медицинских отходов'
          }
        ]
      },
      operatorMedicAttr () {
        return {
          med_garbage_class_id: {
            label: 'Медицинские отходы',
            placeholder: 'цифра',
            required: true,
            validationRulePattern: '^([1-5])$',
            select: {
              options: this.medGarbageClass
            },
            transform: (model) => {
              return this.getMedGarbageClassLabel(model.med_garbage_class_id)
            }
          },
          tkoOperatorServiceName: {
            label: 'Обслуживающий оператор/Рег. оператор',
            validationRulePattern: '(\\.*)',
            placeholder: 'Введите название оператора',
            suggestion: {
              useInnerSearch: true,
              options: [],
              onSelect: this.onSelectOperatorService,
              suggestionEndpoint: this.suggestionEndpointOperatorService,
              transformSuggestions: this.transformSuggestionsOperatorService
            }
          },
          objectNeutralizationName: {
            label: 'Объект обезвреживания',
            validationRulePattern: '(\\.*)',
            placeholder: 'Введите название объекта',
            suggestion: {
              options: [],
              onSelect: this.onSelectObjectNeutralization,
              suggestionEndpoint: this.suggestionObjectNeutralizationEndpoint,
              transformSuggestions: this.transformObjectsSuggestions
            }
          },
          objectBurialName: {
            label: 'Объект захоронения',
            validationRulePattern: '(\\.*)',
            placeholder: 'Введите название объекта',
            suggestion: {
              options: [],
              onSelect: this.onSelectObjectBurial,
              suggestionEndpoint: this.suggestionObjectBurialEndpoint,
              transformSuggestions: this.transformObjectsSuggestions
            }
          }
        }
      },
      operatorMedicDataUrl () {
        if (this.id) {
          let routeQuery = {query: {}}

          return garbage.servicesMed(routeQuery, this.id)
        }

        return garbageOffline.operatorMedicTable(this.$route.name)
      },
      operatorDataUrl () {
        if (this.id) {
          let routeQuery = {query: {}}

          return garbage.services(routeQuery, this.id)
        }

        // if new record, offline save
        return garbageOffline.operatorTable(this.$route.name)
      },
      medGarbageClass () {
        if (this.$store.getters.readUrlEndpoint(this.getMedGarbageClassEndpoint())) {
          return this.$store.getters.readUrlEndpoint(this.getMedGarbageClassEndpoint()).med_garbage_class
        }
        return []
      }
    },
    methods: {
      transformObjectsSuggestions (ctx, response) {
        let data = response.data
        let options = []
        for (let i = 0; i < data.length; i++) {
          options.push({
            originalName: data[i].name,
            name: data[i].name + ' ' + data[i].address,
            id: data[i].id
          })
        }
        return options
      },
      suggestionObjectNeutralizationEndpoint (ctx, q) {
        return tko.objects({
          query: {
            q,
            'per-page': 50,
            actions: [Neutralization]
          }
        })
      },
      onSelectObjectNeutralization (ctx, $event, model, attr) {
        if ($event && $event.id) {
          let copy = Object.assign({}, $event)
          model.objectNeutralizationName = copy.originalName
          model.neutralization_object_id = copy.id
        } else {
          model.objectNeutralizationName = ''
          model.neutralization_object_id = ''
        }
      },
      suggestionObjectBurialEndpoint (ctx, q) {
        return tko.objects({
          query: {
            q,
            'per-page': 50,
            actions: [Burial]
          }
        })
      },
      onSelectObjectBurial (ctx, $event, model, attr) {
        if ($event && $event.id) {
          let copy = Object.assign({}, $event)
          model.objectBurialName = copy.originalName
          model.burial_object_id = copy.id
        } else {
          model.objectBurialName = ''
          model.burial_object_id = ''
        }
      },
      afterFetchMedicData (ctx, data) {
        for (let i = 0; i < data.data.length; i++) {
          if (!data.data[i].hasOwnProperty('tkoOperatorServiceName')) {
            data.data[i].tkoOperatorServiceName = ''
          }
          if (data.data[i].tkoOperatorService) {
            data.data[i].tkoOperatorServiceName = data.data[i].tkoOperatorService.name
          }

          if (!data.data[i].hasOwnProperty('objectNeutralizationName')) {
            data.data[i].objectNeutralizationName = ''
          }
          if (data.data[i].objectNeutralization) {
            data.data[i].objectNeutralizationName = data.data[i].objectNeutralization.name
          }

          if (!data.data[i].hasOwnProperty('objectBurialName')) {
            data.data[i].objectBurialName = ''
          }
          if (data.data[i].objectBurial) {
            data.data[i].objectBurialName = data.data[i].objectBurial.name
          }
        }
        return data
      },
      afterMedicValidate (ctx, model, errors, els) {
        if (model.tkoOperatorServiceName && model.tkoOperatorServiceName.length > 1 && !model.tko_operator_service_id) {
          errors.tkoOperatorServiceName = 'Неверно заполнено поле'
        }
        return errors
      },
      addNewRowToTable () {
        if (this.operationType === 'medic') {
          this.$refs.operatorMedic.createRow({
            med_garbage_class_id: '',
            tkoOperatorServiceName: '',
            objectNeutralizationName: '',
            objectStorageName: ''
          })
        } else {
          this.$refs.operator.createRow({
            tkoOperatorServiceName: '',
            tkoOperatorTransportName: '',
            tkoObjectName: '',
            address: '',
            garbageGroupName: 'ТКО',
            garbage_group_id: 1
          })
        }
      },
      getMedGarbageClassLabel (classId) {
        try {
          return this.medGarbageClass.find(v => v.id === classId).name
        } catch (e) {
          return classId
        }
      },
      fetchData () {
        this.$store.dispatch('updateUrlEndpoint', {
          endpoint: this.getMedGarbageClassEndpoint(),
          fromCache: true
        })
      },
      getMedGarbageClassEndpoint () {
        return core.statuses({fields: 'med_garbage_class'})
      },
      suggestionEndpointObject (ctx, q) {
        return tko.objects({query: {q: q, 'per-page': 50}})
      },
      suggestionEndpointOperatorTransport (ctx, q) {
        return core.statuses({fields: 'tko_operator_transport'})
      },
      suggestionEndpointOperatorService (ctx, q) {
        return core.statuses({fields: 'tko_operator'})
      },
      suggestionEndpointGarbageGroup (ctx, q) {
        return core.statuses({fields: 'garbage_group'})
      },
      operatorPostUrl (context, model) {
        return garbage.servicePost(this.id)
      },
      operatorPatchUrl (context, model) {
        return garbage.servicePatch(model.id)
      },
      operatorDeleteUrl (context, model) {
        return garbage.serviceDelete(model.id)
      },
      operatorMedicPostUrl (context, model) {
        return garbage.serviceMedPost(this.id)
      },
      operatorMedicPatchUrl (context, model) {
        return garbage.serviceMedPatch(model.id)
      },
      operatorMedicDeleteUrl (context, model) {
        return garbage.serviceMedDelete(model.id)
      }
    }
  }
</script>
